import React from "react";
import { Link } from "react-router-dom";

export default function LogoBar({
  title = "HitOrStand",
  leftSlot = null,
  rightSlot = null,
  // legacy children API kept for back-compat
  children,
}) {
  let l = leftSlot;
  let r = rightSlot;
  if (children) {
    if (Array.isArray(children)) {
      l = l || children[0] || null;
      r = r || children[1] || null;
    } else {
      r = r || children;
    }
  }

  return (
    <header
      className="relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, var(--noir-soft) 0%, var(--noir) 100%)",
        borderBottom: "1px solid rgba(200,164,77,0.5)",
        height: 56,
      }}
    >
      <div
        className="px-3 mx-auto flex items-center justify-between gap-2"
        style={{
          position: "relative",
          zIndex: 1,
          height: "100%",
          maxWidth: "48rem",
        }}
      >
        <div style={{ width: 40, display: "flex", justifyContent: "flex-start" }}>
          {l}
        </div>

        <Link
          to="/"
          aria-label={`${title} — Home`}
          className="flex items-center justify-center"
          style={{ flex: "1 1 auto", textDecoration: "none", gap: 10 }}
        >
          <img
            src="/android-chrome-192x192.png"
            alt=""
            width="32"
            height="32"
            decoding="async"
            style={{
              width: 32,
              height: 32,
              borderRadius: 6,
              boxShadow: "0 0 0 1px rgba(200,164,77,0.35)",
              flex: "0 0 auto",
            }}
          />
          <span
            className="font-display text-gold-foil marquee-glow"
            style={{
              fontSize: "clamp(1.25rem, 5.5vw, 1.6rem)",
              fontWeight: 800,
              letterSpacing: "0.005em",
              lineHeight: 1,
            }}
          >
            {title}
          </span>
        </Link>

        <div style={{ width: 40, display: "flex", justifyContent: "flex-end" }}>
          {r}
        </div>
      </div>
    </header>
  );
}
